var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"temp-comp",staticClass:"temp-comp"},[_vm._v("放置区域")])])}
var staticRenderFns = []

export { render, staticRenderFns }